/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const locationSchema = z.enum(['invoice'])

export type LocationSchema = z.infer<typeof locationSchema>
